/**
 * App Name — configured via env var, defaults to MeetingCite.
 *
 * Frontend (NEXT_PUBLIC_APP_NAME): used in page titles, sidebar branding.
 * Backend (APP_NAME): used in the scraper user-agent.
 * Default: 'MeetingCite'
 */
export function getAppName(): string {
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NEXT_PUBLIC_APP_NAME
      ?? process.env.APP_NAME
      ?? 'MeetingCite';
  }
  return 'MeetingCite';
}
